import React from "react";
import { useBreakpointIndex } from "@theme-ui/match-media";
import { Image } from "@theme-ui/components";
import { Box, Flex, Link } from "theme-ui";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import { colors, typography } from "@greythr/shared-components";
import facebook from "../../images/facebook.png";
import twitter from "../../images/twitter.png";
import linkedIn from "../../images/linked-in.png";
import whatsapp from "../../images/whatsapp.png";
import shareLinkLight from "../../images/share-link-light.png";
import shareLink from "../../images/share-link.png";

const getFacebookShareUrl = (url, title, imageSrc, description) => {
  imageSrc = imageSrc ? `&amp;picture=${imageSrc}` : "";
  description = description ? `&amp;description=${description}` : "";
  let shareURL = `https://www.facebook.com/sharer/sharer.php?u=${url}&amp;title=${title}${imageSrc}${description}`;
  return encodeURI(shareURL);
};

const getTwitterShareUrl = (url, title) => {
  let shareURL = `https://twitter.com/intent/tweet?source=${url}&amp;text=${title}`;
  return encodeURI(shareURL);
};

const getLinkedinShareUrl = (url) =>
  `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;

const getWhatsappShareUrl = (url) =>
  `https://api.whatsapp.com/send?text=${url}`;

const LogoWrapper = ({ shareURL, children, copyLink }) => {
  const handleShareClick = (e) => {
    if (copyLink) {
      navigator.clipboard.writeText(shareURL);
      return;
    }
    e.preventDefault();
    window.open(shareURL, "newwindow");
    return false;
  };
  return (
    <Link target="_blank" onClick={handleShareClick} sx={{ cursor: "pointer" }}>
      {children}
    </Link>
  );
};

const ShareSection = ({
  title,
  url,
  imageSrc,
  description,
  variant,
  showCopyLink,
}) => {
  const bp = useBreakpointIndex({ defaultIndex: 2 });
  const facebookShare = getFacebookShareUrl(url, title, imageSrc, description);
  const twitterShare = getTwitterShareUrl(url, title);
  const linkedinShare = getLinkedinShareUrl(url);
  const whatsappShare = getWhatsappShareUrl(url);
  return (
    <Flex sx={{ gap: "1rem" }}>
      <LogoWrapper shareURL={facebookShare}>
        <img src={facebook} alt="facebook" width={40} height={40} />
      </LogoWrapper>
      <LogoWrapper shareURL={twitterShare}>
        <img src={twitter} alt="twitter" width={40} height={40} />
      </LogoWrapper>
      <LogoWrapper shareURL={linkedinShare}>
        <img src={linkedIn} alt="linked in" width={40} height={40} />
      </LogoWrapper>
      <LogoWrapper shareURL={whatsappShare}>
        <img src={whatsapp} alt="whataspp" width={40} height={40} />
      </LogoWrapper>
      {showCopyLink && (
        <Box
          data-tip="Link copied!"
          sx={{
            ".__react_component_tooltip": {
              ...typography.textMd400,
            },
            ".__react_component_tooltip.place-right::after": {
              left: "-5px",
            },
          }}
        >
          <LogoWrapper shareURL={url} copyLink>
            {variant === "light" ? (
              <img src={shareLinkLight} alt="link" width={40} height={40} />
            ) : (
              <img src={shareLink} alt="link" width={40} height={40} />
            )}

            <ReactTooltip
              globalEventOff="click"
              event="click"
              place={bp < 2 ? "bottom" : "right"}
              effect="solid"
              padding="0.5rem 1rem"
              border={true}
              borderColor={colors.primaryMain}
              backgroundColor={colors.primary100}
              textColor={colors.black}
              isCapture={true}
            />
          </LogoWrapper>
        </Box>
      )}
    </Flex>
  );
};

ShareSection.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  description: PropTypes.string,
  variant: PropTypes.string,
  showCopyLink: PropTypes.bool,
};
ShareSection.defaultProps = {
  title: "title",
  url: "url here",
  imageSrc: "image url here",
  description: "description",
  showCopyLink: true,
};

export default ShareSection;
